export default [
  { id: 1, value: 'lunes', option: 'Lunes' },
  { id: 2, value: 'martes', option: 'Martes' },
  { id: 3, value: 'miércoles', option: 'Miércoles' },
  { id: 4, value: 'jueves', option: 'Jueves' },
  { id: 5, value: 'viernes', option: 'Viernes' },
  { id: 6, value: 'sábado', option: 'Sábado' },
  { id: 7, value: 'domingo', option: 'Domingo' }
]
